import { GetLinks } from "../../../config";

export default [
  {
    key: "/sellers",
    icon: <i className="ki-outline ki-briefcase fs-1 " />,
    label: GetLinks("/sellers", "Sellers"),
  },
];
